import * as React from 'react';

import { LinkField } from '@uncinc/react-drupal-core/types';
import LinkListHomepage from './Homepage';
import LinkListVariantNormal from './Normal';
import LinkListItemHomepage from './Homepage/Item';
import LinkListItemNormal from './Normal/Item';

interface LinkListSubComponents {
  Item: typeof LinkListItem;
}

interface LinkListProps {
  isHomepage?: boolean;
  title?: string;
  body?: string;
  buttons?: LinkField[];
}

const LinkList: React.FC<LinkListProps> & LinkListSubComponents = (props) => {
  const { isHomepage } = props;

  if (isHomepage) {
    return <LinkListHomepage {...props} />;
  }

  return <LinkListVariantNormal {...props} />;
};

// eslint-disable-next-line max-len
const LinkListItem: React.FC<React.ComponentProps<typeof LinkListItemHomepage> & { isHomepage?: boolean }> = (props) => {
  const { isHomepage, ...rest } = props;

  if (isHomepage) {
    return <LinkListItemHomepage {...rest} />;
  }

  return <LinkListItemNormal {...rest} />;
};

LinkList.Item = LinkListItem;

export default LinkList;
